import { 
  initiateKakaoLogin as supabaseInitiateKakaoLogin,
  processKakaoLogin as supabaseProcessKakaoLogin,
  getKakaoToken as supabaseGetKakaoToken,
  logout as supabaseLogout
} from './supabaseAuthService';
import { logError } from '../utils/errorHandling';

const KAKAO_REST_API_KEY = 'feeb3a5546b4caa1e4e3364aee4b583e';
const REDIRECT_URI = `${window.location.origin}/auth/kakao/callback`;

// Supabase 버전으로 교체
export const initiateKakaoLogin = supabaseInitiateKakaoLogin;
export const getKakaoToken = supabaseGetKakaoToken;
export const processKakaoLogin = supabaseProcessKakaoLogin;
export const logout = supabaseLogout; 